var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCameraIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.207 2.5a2.5 2.5 0 00-2.08 1.113l-.722 1.083a1.5 1.5 0 01-1.248.668H3.409A2.41 2.41 0 001 7.773v10.5a2.41 2.41 0 002.41 2.409H20.59a2.409 2.409 0 002.41-2.41v-10.5a2.41 2.41 0 00-2.41-2.408h-2.748a1.5 1.5 0 01-1.248-.668l-.721-1.083a2.5 2.5 0 00-2.08-1.113h-3.587zm1.537 6.55a3.563 3.563 0 10.512 7.106 3.563 3.563 0 00-.512-7.106zm-1.304 2.203a2.062 2.062 0 113.119 2.699 2.062 2.062 0 01-3.119-2.699z",
    fill: "#fff"
  })));
}

export default SvgCameraIconWhite;